const LOGO_SRC = `${process.env.PUBLIC_URL}/agrobridge-logo.svg`;

const LogoIcon = ({ size = 37, className }) => {
    return (
        <img
            src={LOGO_SRC}
            alt="AgroBridge"
            className={className}
            height={size}
            style={{ height: size, width: 'auto', display: 'block' }}
        />
    )
}

export default LogoIcon
